import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialColumns, initialFilter } from "./RegistrationCancellationReportUIHelpers";

const RegistrationCancellationReportUIContext = createContext();

export function useRegistrationCancellationReportUIContext() {
  return useContext(RegistrationCancellationReportUIContext);
}

export const RegistrationCancellationReportUIConsumer = RegistrationCancellationReportUIContext.Consumer;

export function RegistrationCancellationReportUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [columns, setColumns] = useState(initialColumns);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    columns,
    setColumns,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <RegistrationCancellationReportUIContext.Provider value={value}>
      {children}
    </RegistrationCancellationReportUIContext.Provider>
  );
}